export class Device {
    ID: string;
    client_ID: string;
    user_ID: string;
    pin: string;
    name: string;
    model_category: string;
    model_category_name: string;
    model_name: string;
    status: string;
    system_version: string;
    push_token: string;
    push_token_type: string;
    badge_count: string;
}
  


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/device.model.ts